import { Injectable } from "@angular/core";
import { NotificationService, WmHttpService } from "@wms/app/services";
import { find, forEach, get, isEmpty, pickBy, remove, set, findIndex } from "lodash-es";
import { BaseComponent } from "@wms/app/components";
import { Subject } from "rxjs";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ArtifactsService extends BaseComponent {
  prefabs: any;
  prefabCategories: any;
  searchKey: any;
  prefabDeleteArray: any = [];
  prefabNamesArray: any = [];
  themeDeleteArray: any = [];
  themeNamesArray: any = [];
  projectShellDeleteArray: any = [];
  projectShellNamesArray: any = [];
  templateBundleDeleteArray: any = [];
  templateBundleNamesArray: any = [];
  themesGroup: any;
  themes: any;
  templateBundles: any;
  artifactType: any;
  projectPrefabs: any;
  teamPrefabs: any;
  systemPrefabs: any;
  marketplacePrefabs: any;
  workspacePrefabs: any = [];
  changeLogObjs: any
  prefabsList: any;
  pageObj: any;
  pageSize: any;
  updatesCount: any;
  importingArtifact: any;
  fetchingChangeLog: any;
  artifactImportVersion: any;
  loadingPrefabs: any;
  nextPage: any;
  prefabType: any;
  prefabTypeDesc: any;
  artifactState: any;
  defaultArtifactType = 'PROJECTSHELL';
  private TARGET: string = "Artifacts";
  allowArtifactVerChange: boolean;
  artifactDetailsHeader: any;
  themeObjs: any = [];
  private API_META: any = {
    getChangeLog: {
      url: "/edn-services/rest/repository/artifacts/:artifactId?include-versions=true",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    getArtifactUpdateVersionList: {
      url: "/edn-services/rest/repository/artifacts/:artifactId?include-versions=true&min-version=:version",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    getArtifactUpdate: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/updates",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },

    getList: {
      url: "/edn-services/rest/repository/artifacts?status=PUBLISHED&artifact-type=:artifactType&include-system=:include-system&include-enterprise=:include-enterprise&include-marketplace=:include-marketplace&pageNumber=:pageNumber&pageSize=:pageSize&projectId=:projectId&q=:q",
      method: "GET"
    },
    getCategories: {
      url: "/edn-services/rest/artifacts/categories?response-format=LIST",
      method: "GET"
    },
    import: {
      url: "/edn-services/rest/projects/:projectId/artifacts",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    updatePrefabVersion: {
      url: "/edn-services/rest/projects/:projectId/artifacts/:artifactId",
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    getSystemMetadata: {
      url:"/edn-services/rest/system-custom-metadata",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    setCategory: {
      url:"/edn-services/rest/artifacts/categories",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    publishToTeam: {
      url:"/edn-services/rest/repository/queue/artifacts",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      spinnerInfo: {
        showSpinner: false
      }
    },
    versionAvailableToPublish: {
      url:"/edn-services/rest/repository/artifacts/:artifactId/versions/validate?version=:version",
      method: "GET"
    },
    getDependencies: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/artifacts/:artifactType/dependencies",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    getArtifact: {
      url:"/edn-services/rest/repository/artifacts/revisions/latest?artifactType=:artifactType&artifactName=:artifactName&branch=:branch",
      method: "GET",
      spinnerInfo: {
        showSpinner: false
      }
    },
    switchPrefabPublisher: {
      url: "/edn-services/rest/projects/:projectId/artifacts/switch?studioProjectId=:studioProjectId&forceUpdate=:forceUpdate",
      method: "POST",
      headers: {
          'Content-Type': 'application/json'
      }
  }
  };
  ALL_CATEGORIES: any;
  FILTER_ALL = 'all';
  FILTER_SYSTEM = 'sys';
  FILTER_ENTERPRISE = 'ent';
  FILTER_MARKETPLACE = 'marketplace';
  queryFilterParams: any = {};
  categories: any;
  artifacts: any = [];
  metadataObjs: any;
  showList: any;
  defaultFilter: any;
  filter: any;
  tempSetCategories: any;
  setCategories: any;
  activeArtifactObj: any;
  fetchPaginatedPrefabs: any = new Subject();
  setDefaultPrefab: any = new Subject();
  triggerArtifactSearch: any = new Subject();
  setActivePrefab: any = new Subject();
  projectShellObjs: any = [];
  templateBundleObjs: any = [];
  oauth2Providers: any = [];
  loadingArtifacts: boolean;
  selectedPrefabName: any;

  constructor(private wmHttpService: WmHttpService, private notificationService: NotificationService) {
    super();
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.ALL_CATEGORIES = this.locale.LABEL_ARTIFACT_ALL_CATEGORIES;
    set(this.queryFilterParams, this.FILTER_ALL, {
      'include-system': true,
      'include-enterprise': true,
      'include-marketplace': false
    });
    set(this.queryFilterParams, this.FILTER_SYSTEM, {
      'include-system': true,
      'include-enterprise': false,
      'include-marketplace': false
    });
    set(this.queryFilterParams, this.FILTER_ENTERPRISE, {
      'include-system': false,
      'include-enterprise': true,
      'include-marketplace': false
    });
    set(this.queryFilterParams, this.FILTER_MARKETPLACE, {
      'include-system': false,
      'include-enterprise': false,
      'include-marketplace': true
    });
  }

  reset() {
    this.prefabDeleteArray = [];
    this.prefabNamesArray = [];
    this.themeDeleteArray = [];
    this.themeNamesArray = [];
    this.projectShellDeleteArray = [];
    this.projectShellNamesArray = [];
    this.templateBundleDeleteArray = [];
    this.templateBundleNamesArray = [];
  }

  paginatedPrefabsObs() {
    return this.fetchPaginatedPrefabs.asObservable();
  }

  setDefaultPrefabObs() {
    return this.setDefaultPrefab.asObservable();
  }

  triggerArtifactSearchObs() {
    return this.triggerArtifactSearch.asObservable();
  }

  setActivePrefabObs() {
    return this.setActivePrefab.asObservable();
  }

  setPrefabDefaults() {
    this.projectPrefabs = [];
    this.teamPrefabs = [];
    this.systemPrefabs = [];
    this.marketplacePrefabs = [];
    this.prefabsList = [];
    this.pageObj = {};
    this.pageSize = 10;
    this.updatesCount = 0;
    this.importingArtifact = this.fetchingChangeLog = false;
    this.searchKey = '';
    this.artifactImportVersion = [];
    this.loadingPrefabs = false;
    this.resetPageNumber();
  }

  /**
   * storing the current tab state
   */
  storeTabData() {
    this.artifactType = this.artifactType || this.defaultArtifactType;
    set(this.artifactState, this.artifactType + '.searchKey', this.searchKey);
    set(this.artifactState, this.artifactType + '.filter', this.filter);
    set(this.artifactState, this.artifactType + '.setCategories', this.setCategories);
    set(this.artifactState, this.artifactType + '.artifacts', this.artifacts);
    set(this.artifactState, this.artifactType + '.activeArtifactObj', this.activeArtifactObj);
    set(this.artifactState, this.artifactType + '.pageObj', this.pageObj);
    set(this.artifactState, this.artifactType + '.pageObj.pageNumber', this.nextPage);
  }

  resetPageNumber() {
    // TODO: check if page number should start from 0 or 1
    this.nextPage = 1;
  }

  updatePrefabVersion(artifactId: any, params: any) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "updatePrefabVersion",
      data: params,
      urlParams: {
        artifactId: artifactId,
        projectId: this.projectService.projectEdnDetails.projectId,
      }
    }) as Promise<any>);
  }

  getAllCategories() {
    if (!this.categories.length) {
      (this.wmHttpService.execute({
        target: this.TARGET,
        action: "getCategories"
      }) as Promise<any>).then((categoryObjs) => {
        forEach(categoryObjs, (catObj, i) => {
          this.categories.push(catObj.name)
        });
        this.categories = this.prependAllCategories(this.categories);
      }).catch((err: any) => {
        this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], err);
      });
    }
  }

  /**
    * restoring the data to previous state before switching to another tab. If this is the first time, default data is set
    */
  restoreTabData() {
    this.showList = true;
    this.importingArtifact = this.fetchingChangeLog = false;
    this.restoreSearchKey();
    this.restoreFilter();
    this.restoreCategories();
    this.restorePageObj();
    this.restoreArtifacts();
    this.restoreActiveArtifactObj();
    this.getArtifactDetails(this.activeArtifactObj);
  }

  getArtifactDetails(artifactObj: any, showSpinner?: boolean) {
    if (!isEmpty(artifactObj)) {
      this.getArtifactChangeLog(artifactObj, showSpinner);
      this.setChangeLogAccordions();
    }
  }

  setChangeLogAccordions() {
    // TODO - needed?
    //open the first accordion group by default
    // this.accordianStatus = {isItemOpen: new Array(this.artifacts.length), isFirstDisabled: false};
    // this.accordianStatus.isItemOpen[0] = true;
  }

  /**
   * fetches the changelog data for the selected artifact
   * @param artifactObj
   */
  getArtifactChangeLog(artifactObj: any, showSpinner?: boolean) {
    if (artifactObj.changeLogObjs) {
      this.changeLogObjs = artifactObj.changeLogObjs;
      this.artifactImportVersion[0] = this.changeLogObjs[0];
    } else {
      this.fetchingChangeLog = true;
      var headers = {
        'X-WM-Platform-Version': artifactObj.artifactVO.platformVersion
      };
      this.getChangeLog(artifactObj.artifactVO.artifactId, headers, showSpinner).then((artifactObj) => {
        this.mergeArtifactObj(artifactObj);
        this.fetchingChangeLog = false;
        this.changeLogObjs = artifactObj.changeLogObjs = artifactObj.artifactVO.versionList;
        this.artifactImportVersion[0] = this.changeLogObjs[0];
      }).catch((err) => {
        this.fetchingChangeLog = false;
        this.notificationService.show("error", this.locale["MESSAGE_ERROR_TITLE"], err);
      });
    }
  }

  mergeArtifactObj(artifactObj: any) {
    let artifactIndex = findIndex(this.artifacts, (ao: any) => { return ao.artifactVO.artifactId === artifactObj.artifactVO.artifactId });
    let existingArtifactObj: any = this.artifacts[artifactIndex];
    artifactObj.workspaceArtifact = existingArtifactObj.workspaceArtifact;
    this.artifacts[artifactIndex] = artifactObj;
    this.setPlatformType(artifactObj);
    this.setDocumentationFlag(artifactObj);
    this.setAsActiveArtifact(artifactObj);
  }

  setDocumentationFlag(artifactObj: any) {
    artifactObj.artifactVO._isDocumentAvailable = true;
  }

  /**
   * set the active state for the selected artifact
   * @param artifactObj
   */
  setAsActiveArtifact(artifactObj: any) {
    this.activeArtifactObj = artifactObj;
  }

  setPlatformType(artifactObj: any) {
    let metadata = get(artifactObj, 'artifactVO.artifactMetadataList', []);
    //default value is WEB
    set(artifactObj, 'artifactVO._platformType', 'WEB');
    if (metadata.length) {
      let obj = find(metadata, (md) => { return md.value === 'MOBILE' || md.value === 'NATIVE_MOBILE' });
      if (obj) {
        set(artifactObj, 'artifactVO._platformType', 'MOBILE');
      }
    }
  }

  /**
   * get the existing search key or else set it empty
   */
  restoreSearchKey() {
    this.searchKey = get(this.artifactState, this.artifactType + '.searchKey', '');
  }

  /**
   * get the existing filter or else set it to default filter
   */
  restoreFilter() {
    this.filter = get(this.artifactState, this.artifactType + '.filter', this.defaultFilter);
  }

  /**
   * if the setCategories is not found, then set the default categories
   */
  restoreCategories() {
    this.setCategories = get(this.artifactState, this.artifactType + '.setCategories', {});
    if (!Object.keys(this.setCategories).length) {
      this.setDefaultCategories();
    }
  }

  /**
   * get the existing artifacts or else set it to empty array
   */
  restoreArtifacts() {
    this.artifacts = get(this.artifactState, this.artifactType + '.artifacts', []);
  }

  /**
   * get the existing activeArtifactObj or else set it to empty object
   */
  restoreActiveArtifactObj() {
    this.activeArtifactObj = get(this.artifactState, this.artifactType + '.activeArtifactObj', {});
  }

  /**
   * get the existing pageObj or else set it to empty object
   */
  restorePageObj() {
    this.pageObj = get(this.artifactState, this.artifactType + '.pageObj', {});
    this.nextPage = get(this.artifactState, this.artifactType + '.pageObj.pageNumber', 1);
  }

  prependAllCategories(categories: any) {
    categories.unshift(this.ALL_CATEGORIES);
    return categories;
  }

  importToWorkSpace(data: any) {
    let params = {
      "artifactId": data.artifactId,
      "versionId": data.versionId
    };
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "import",
      data: params,
      urlParams: {
        projectId: this.projectService.projectEdnDetails.projectId
      }
    }) as Promise<any>);

  }

  /**
   * initial state of the artifact tabs
   */
  setArtifactDefaults() {
    this.artifactState = {};
    this.artifacts = [];
    this.pageObj = {};
    this.categories = [];
    this.metadataObjs = [];
    this.showList = true;
    this.importingArtifact = this.fetchingChangeLog = false;
    this.defaultFilter = this.filter = this.FILTER_ALL;
    this.searchKey = '';
    this.tempSetCategories = {};
    this.artifactImportVersion = [];
    this.activeArtifactObj = {};
    this.setDefaultCategories();
    this.resetPageNumber();
  }

  resetActiveArtifactObj() {
    this.activeArtifactObj = {};
  }

  /**
   * default category state
   */
  setDefaultCategories() {
    this.setCategories = {};
    set(this.setCategories, this.ALL_CATEGORIES, true);
  }

  incrementPageNumber() {
    this.nextPage += 1;
  }

  decrementPageNumber() {
    this.nextPage -= 1;
  }

  toggleRemoveState(resourceType: any, resource: any, event: any) {
    let currentTarget = $(event.currentTarget);
    /*checking if delete icon present*/
    if (currentTarget.children().hasClass("wms-delete")) {
      /*if prefab selected for deletion, then push selected prefab to delete object*/
      if (resourceType === "prefab") {
        this.prefabDeleteArray.push({
          'prefabId': resource.id,
          'prefabName': resource.name,
          'versionId': resource.versionId
        });
        this.prefabNamesArray.push(resource.name);
      } else if (resourceType === "theme") {
        /*if theme selected for deletion, then push selected theme to delete object*/
        this.themeDeleteArray.push({
          'themeID': resource.id,
          'themeName': resource.name,
          'versionId': resource.versionId
        });
        this.themeNamesArray.push(resource.name);
      } else if (resourceType === "projectShell") {
        this.projectShellDeleteArray.push({
          'projectShellID': resource.id,
          'projectShellName': resource.name,
          'versionId': resource.versionId
        });
        this.projectShellNamesArray.push(resource.name);
      } else if (resourceType === "templateBundle") {
        this.templateBundleDeleteArray.push({
          'templateBundleID': resource.id,
          'templateBundleName': resource.name,
          'versionId': resource.versionId
        });
        this.templateBundleNamesArray.push(resource.name);
      }
      /*change icon to marked for deletion*/
      currentTarget.children().removeClass("wms-delete").addClass("wms-undo");
      currentTarget.parent().parent().addClass("marked-deleted");
    } else {
      /*if close icon found, then reset the delete selection*/
      if (resourceType === "prefab") {
        /*if prefab is selected for reset delete action, remove the selected prefab from the object*/
        remove(this.prefabDeleteArray, ['prefabId', resource.id]);
        this.prefabNamesArray.splice(this.prefabNamesArray.indexOf(resource.name), 1);
      } else if (resourceType === "theme") {
        /*if theme is selected for reset delete action, remove the selected theme from the object*/
        remove(this.themeDeleteArray, ['themeID', resource.id]);
        this.themeNamesArray.splice(this.themeNamesArray.indexOf(resource.name), 1);
      } else if (resourceType === "projectShell") {
        /*if theme is selected for reset delete action, remove the selected theme from the object*/
        remove(this.projectShellDeleteArray, ['projectShellID', resource.id]);
        this.projectShellNamesArray.splice(this.projectShellNamesArray.indexOf(resource.name), 1);
      } else if (resourceType === "templateBundle") {
        /*if theme is selected for reset delete action, remove the selected theme from the object*/
        remove(this.templateBundleDeleteArray, ['templateBundleID', resource.id]);
        this.templateBundleNamesArray.splice(this.templateBundleNamesArray.indexOf(resource.name), 1);
      }
      /*change icon to delete again*/
      currentTarget.children().removeClass("wms-undo").addClass("wms-delete");
      currentTarget.parent().parent().removeClass("marked-deleted");
    }
  }

  getArtifactsUpdateVersionList(artifactId: any, version:any  , headers: any, showSpinner: boolean = false) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getArtifactUpdateVersionList",
      urlParams: {
        artifactId: artifactId,
        version: version
      },
      spinnerInfo: {
        showSpinner: showSpinner
      },
      headers: headers
    }) as Promise<any>);
  }

  getChangeLog(artifactId: any, headers: any, showSpinner: boolean = false) {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getChangeLog",
      urlParams: {
        artifactId: artifactId
      },
      spinnerInfo: {
        showSpinner: showSpinner
      },
      headers: headers
    }) as Promise<any>);
  }

  getQueryFilterParams(filterType: any) {
    return this.queryFilterParams[filterType];
  }

  getList(artifactType: any, pageNumber: any, filter: any, categories: any, searchKey: any, pageSize: any, projectId: any) {
    let additionalParams: any = {};
    // categories - if this contains default one and length > 1 means something else is selected then add it to query params
    // or if the default category is not present and categories length > 0 means other than default some category is selected
    // in these both cases only pass the category filter
    let catgrs = Object.keys(pickBy(categories));
    if ((catgrs.indexOf(this.ALL_CATEGORIES) !== -1 && catgrs.length > 1) || (catgrs.indexOf(this.ALL_CATEGORIES) === -1 && catgrs.length)) {
      additionalParams['category'] = remove(Array.from(catgrs), (cat) => {
        return cat !== this.ALL_CATEGORIES;
      }).join(",");
    }
    if (searchKey) {
      additionalParams['q'] = searchKey;
    } else {
      additionalParams['q'] = '';
    }
    if (pageSize) {
      additionalParams['pageSize'] = pageSize;
    }
    if (projectId) {
      additionalParams['projectId'] = projectId;
    }
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getList",
      urlParams: Object.assign({}, this.getQueryFilterParams(filter), additionalParams, {
        pageNumber: pageNumber,
        artifactType: artifactType
      }),
    }) as Promise<any>);
  }

  getCategories(): Promise<any> {
    return (this.wmHttpService.execute({
      target:this.TARGET,
      action:'getCategories',
      spinnerInfo: {
        showSpinner: false
      },
    }) as Promise<any>)
  }

  getSystemMetadata(): Promise<any> {
    return (this.wmHttpService.execute({
      target:this.TARGET,
      action:'getSystemMetadata',
    }) as Promise<any>)
  }

  getDependencies(projectId: any, artifactType: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getDependencies',
      urlParams: {
        projectID: projectId,
        artifactType: artifactType
      }
    }) as Promise<any>)
  }

  getArtifact(artifactName: any, artifactType: any, branch: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'getArtifact',
      urlParams: {
        artifactName: artifactName,
        artifactType: artifactType,
        branch: branch
      }
    }) as Promise<any>)
  }

  versionAvailableToPublish(artifactId: any, version: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'versionAvailableToPublish',
      urlParams: {
        artifactId: artifactId,
        version: version
      }
    }) as Promise<any>)
  }

  publishToTeam(params: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'publishToTeam',
      data: params
    }) as Promise<any>)
  }

  setCategory(params: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'setCategory',
      data: params
    }) as Promise<any>)
  }

  switchPrefabPublisher(projectId:any,studioProjectId:any,forceUpdate:any,params: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'switchPrefabPublisher',
      data: params,
      urlParams: {
        projectId : projectId,
        studioProjectId : studioProjectId,
        forceUpdate : forceUpdate
    }
    }) as Promise<any>)
  }

  getArtifactsUpdates(){
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "getArtifactUpdate",
      urlParams: {
        projectID: this.projectService.getProjectId(),
      }
    }) as Promise<any>);

  }


}
